import { createReducer, on } from '@ngrx/store';

import { HomeConfig } from '../../../domain/state/core.state';

import { SetLastSectionTranslated } from './seo.actions';
import { seoInitialState } from './seo.state';

import { ConfigureHomeLinkSuccess } from '@core/infrastructure/state/core-events.actions';

export const seoReducers = createReducer(
    seoInitialState,
    on(ConfigureHomeLinkSuccess, (state, { homeConfs }) => {
        return {
            ...state,
            homeUrls: homeConfs.map((homeConfig: HomeConfig) => {
                return homeConfig.locationPath;
            }),
        };
    }),
    on(SetLastSectionTranslated, (state, { lastSectionTranslated }) => {
        return {
            ...state,
            lastSectionTranslated,
        };
    }),
);
